import React from 'react'
import { FundItem } from '../../../../models/Fund';
import ContentBox from '../../../common/ContentBox';
import { Box, Button, ITheme, Typography, useTheme } from '@mui/material';
import FavoriteFundButton from '../../FavoriteFundButton';
import { useTranslation } from 'react-i18next';
import { LeoImagesFundsPath } from '../../../../resources/api-constants';
import { Utilities } from '../../../../utility/utils';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../../resources/routes-constants';

export interface IOverviewGeneralInfoProps {
  fund: FundItem;
  createPortfolio?: boolean;
}

const OverviewGeneralInfo: React.FC<IOverviewGeneralInfoProps> = ({ fund, createPortfolio }) => {
  const theme = useTheme() as ITheme;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const addToNew = (event: React.MouseEvent<any>) => {
    event.stopPropagation();
    navigate(AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_WITH_FUND_ROUTE.replace(":id", `${fund.id}`));
  }
  const addToExisting = (event: React.MouseEvent<any>) => {
    event.stopPropagation();
    navigate(AUTHENTICATED_ROUTES.PORTFOLIO_ADD_TO_ROUTE.replace(":id", `${fund.id}`));
  }

  const scheduleACall = (event: React.MouseEvent<any>) => {
    event.stopPropagation();
    window.open("https://calendly.com/nadimabouchaar/leo-demo");
  }

  return (
    <ContentBox proportion={1}>
      <Box display={"flex"} flexDirection={"column"} gap={"20px"}>
        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          {fund.eltif ?
            <Box height={"22px"} width={"67px"} bgcolor={theme.palette.leo.tone5} borderRadius={"4px"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
              <Typography color={theme.palette.common.white} fontSize={"11px"} lineHeight={"20px"} fontWeight={"600"}>{t('LibraryOfFundsELTIF')}</Typography>
            </Box>
            :
            <Box></Box>}
          <FavoriteFundButton fundId={fund.id} />
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"}>
            <img src={`${LeoImagesFundsPath}/${fund.logo}`} style={{ maxWidth: "150px", maxHeight: "31px", objectFit: "contain" }} />
            <Typography fontSize={"14px"} fontWeight={"700"} lineHeight={"17.07px"} color={theme.palette.text.primary}>{fund.name}</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography fontSize={"24px"} fontWeight={"600"} lineHeight={"29.26px"} color={theme.palette.text.primary}>€{Utilities.toFriendlyMoneyValue(fund.fundSize)}</Typography>
            <Typography fontSize={"10px"} fontWeight={"600"} lineHeight={"20px"} color={theme.palette.text.secondary}>{t('LibraryOfFundsFundSize')}</Typography>
          </Box>
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"16px"} paddingTop={"16px"}>
          <Button variant='contained' onClick={addToNew} disabled={createPortfolio}>{t('LibraryOfFundsOverviewTabAddNewPortfolio')}</Button>
          <Button variant='outlined' onClick={addToExisting} disabled={createPortfolio}>{t('LibraryOfFundsOverviewTabAddExistingPortfolio')}</Button>
          <Button variant='text' onClick={scheduleACall}>{t('LibraryOfFundsOverviewTabScheduleCall')}</Button>
        </Box>
      </Box>
    </ContentBox>
  )
}

export default OverviewGeneralInfo;